import {
  SET_ASSUMPTIONS,
} from "./mutations";

const initialState = {
  assumptions: null,
};

const waterfallReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_ASSUMPTIONS:
      return { ...state, assumptions: payload };
      
    default:
      return state;
  }
};

export default waterfallReducer;
